import React from "react";
import TechCarousel from "../Components/Carousels/TechCarousel/TechCarousel";
import "./Technologies.css";

export default function Technologies() {
  return (
    <>
      <div id="myskills" className="text-white kajal  ">
        <h5
          data-aos="zoom-in-right"
          className="ppp my-5 py-3 text-white text-center heading ak "
        >
          My skills
        </h5>
        <p data-aos="zoom-in-right" className="top_Tech_para my-5">
          Personal development skills are personal attributes, personality
          traits, inherent social cues and communication abilities. Developing
          these skills involves the process of self-improvement, which focuses
          on strengthening your knowledge, capabilities, and self-awareness to
          reach your personal goals.
        </p>
      </div>
      <TechCarousel />
      <hr
        id="ourTools"
        style={{ border: "1px solid white" }}
        className="my-0"
      />
    </>
  );
}
